export enum HideLastpageNumber {
  ALL = 'all',
  NUMBER = 'number'
}
